<template>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <router-link
      :class="{ 'breadcrumb-item': true, active: isActivated(crumb) }"
      v-for="(crumb, key) in breadcrumbs"
      :key="key"
      :to="lastLink(crumb.path)"
 
    >
      <i v-if="crumb.meta.icon" class="fas breadcrumb-icon" :class="crumb.meta.icon"></i> {{ crumb.meta.breadcrumb }}
    </router-link>
  </ol>
</nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data () {
    return {
      breadcrumbs: []
    }
  },
  mounted () {
    this.breadcrumbs = this.$route.matched.filter(match => match.meta.breadcrumb)
  },
  methods: {
    isActivated(crumb) {
      const last = this.breadcrumbs[this.breadcrumbs.length - 1]
      return last.meta.breadcrumb === crumb.meta.breadcrumb
    },
    lastLink (path) {
      const last = this.breadcrumbs[this.breadcrumbs.length - 1].path
      if (path === last) {
        return this.$router.currentRoute.path
      }
      return path
    }
  }
}
</script>

<style scoped>
.breadcrumb-item {
  color: inherit;
  text-decoration: none;
}

.breadcrumb-icon {
  font-size: 10px;
}

.active {
  font-weight: bold;
}
</style>
